import { v1 as uuidv1 } from 'uuid';
import ThumbnailCard from '../common/ThumbnailCard';
import { getPageStyle } from '../common/LessonPageUtil';
import { filterUndefined } from '../../../../utils/FilterUndefinedObject';
import './CategorizingCardThumbnail.scss';

const DISPLAY_LIMIT = 2;
const defaultProps = {
  instructionConfig: {},
  promptCardsConfig: [],
  responseCardsConfig: [],
  isSmallThumbnail: false,
};
export default function CategorizingCardThumbnail(props) {
  const { instructionConfig, promptCardsConfig, responseCardsConfig, isSmallThumbnail } = { ...defaultProps, ...filterUndefined(props) };
  const createCard = (className, cards, isImageIncluded) => (
    cards.map((c) => {
      const caredId = uuidv1();
      return (
        <ThumbnailCard
          id={caredId}
          key={caredId}
          image={c.image}
          text={c.text}
          isSmallThumbnail={isSmallThumbnail}
          className={className}
          style={getPageStyle(c, true)}
          isImageIncluded={isImageIncluded}
        />
      );
    })
  );

  const getCards = (cardConfig, className, cardContinerClassName, isImageIncluded) => (
    cardConfig.length > DISPLAY_LIMIT ? (
      <div className='display-partial'>
        <div className={cardContinerClassName}>
          {createCard(className, cardConfig.slice(0, DISPLAY_LIMIT), isImageIncluded)}
        </div>
        <div className='display-partial-text'>
          {cardConfig.length - DISPLAY_LIMIT} more card{cardConfig.length - DISPLAY_LIMIT > 1 ? 's' : ''}
        </div>
      </div>
    ) : createCard(className, cardConfig, isImageIncluded)
  );

  return (
    <div className='catorizing-card-thumbnail'>
      <div className='catorizing-card-responses-container'>
        {!instructionConfig || (!instructionConfig.text && !instructionConfig.image)
          ? (
            <div className='instruction-thumbnail instruction'>
              Instruction
            </div>
          )
          : (
            <ThumbnailCard
              id={uuidv1()}
              image={instructionConfig.image}
              text={instructionConfig.text}
              isSmallThumbnail={isSmallThumbnail}
              className='instruction-thumbnail'
            />
          )}
        <div className={`catorizing-card-responses ${isSmallThumbnail ? 'small' : ''}`}>
          {getCards(responseCardsConfig, 'catorizing-card-response', 'display-partial-response')}
        </div>
      </div>
      <div className='catorizing-card-prompts'>
        {getCards(promptCardsConfig, 'catorizing-card-prompt', 'display-partial-prompt', false)}
      </div>
    </div>
  );
}
